import { Container, Row, Col } from "react-bootstrap";
import { BzModal, BzModalHeader, BzModalBody, BzModalFooter, BzChip, BzButton } from "../../components";
import { useDispatch, useSelector } from 'react-redux';
import { memo } from "react";
import { handleModal } from "../../redux/actions/modals";

// Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
const RecommendationFilterModal = ({ objFilters, setObjFilters, setObjRecommendationFiltersInputs, setIsFilter, setArrRecommendations, recommendationsWithScripInfo }) => {
    // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const recommendationsFilterOptions = useSelector(state => state?.recommendation.recommendationsFilterOptions);
    const handleClose = () => {
        dispatch(handleModal([{ "RECOMMENDATION_FILTER_MODAL": false }]));
    };

    const handleOnFilterApply = () => {
        setObjRecommendationFiltersInputs({ ...objFilters });
        setIsFilter(true);
        dispatch(handleModal([{ "RECOMMENDATION_FILTER_MODAL": false }]));
    };

    const handleResetObjFilters = () => {
        // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
        setArrRecommendations(recommendationsWithScripInfo);
        // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
        setIsFilter(false);
        setObjFilters({});
        setObjRecommendationFiltersInputs({});
    };

    const handleFilterInputs = (filterName, filterValue) => {
        setObjFilters(curr => { return { ...curr, [filterName]: filterValue }; });
    };

    return (
        <BzModal size='md' show={modals['RECOMMENDATION_FILTER_MODAL']} onHide={handleClose}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Filters</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                {recommendationsFilterOptions && recommendationsFilterOptions?.map((each, i) => (
                    //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start
                    each?.options?.length ? <div className='py-3' key={i}>
                        {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start */}
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-medium font-size3 color-text'>{each.key}</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col className='multi-chips-wrap'>
                                {each?.options?.map((eachTabg) => (
                                    <BzChip onClick={() => { handleFilterInputs(each?.optionType, eachTabg); }} className={`multi-chip me-2 mb-3 text-capitalize ${objFilters[each?.optionType] === eachTabg ? 'active' : ''}`}>{eachTabg}</BzChip>
                                ))}
                            </Col>
                        </Row>
                    </div> : <></>
                ))}
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='m-0 p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-end aign-items-center'>
                            <BzButton className={`btn btn-outline font-size2 me-3 ${Object.keys(objFilters)?.length ? '' : 'disabled'}`} onClick={handleResetObjFilters}>Reset Filters</BzButton>
                            <BzButton className={`btn btn-primary font-size2 ${Object.keys(objFilters)?.length ? '' : 'disabled'}`} onClick={handleOnFilterApply}>Apply</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal >
    );
};

export default memo(RecommendationFilterModal)






